import { AdminRoutesVariables } from './admin'
import { ErrorRoutesVariables } from './error'
import { ExternalRoutesVariables } from './external'
import { OnboardingRoutesVariables } from './onboarding'
import { WorkerRoutesVariables } from './worker'

export const Routes = {
  ...OnboardingRoutesVariables,
  ...WorkerRoutesVariables,
  ...AdminRoutesVariables,
  ...ExternalRoutesVariables,
  ...ErrorRoutesVariables,
  Login: '/login',
  Storybook: 'storybook',
  Mobile: '/mobile',
}
